import {CartIcon} from "../assets/icons/CartIcon";
import {MarketingIcon} from "../assets/icons/MarketingIcon";
import {UtilityIcon} from "../assets/icons/UtilityIcon";
import {ChatIcon} from "../assets/icons/ChatIcon";

export const getMessageTypeIcon = (flowTypeId: number) => {
    if(flowTypeId === 1) {
        return <CartIcon width={48} />
    } else if(flowTypeId === 2) {
        return <MarketingIcon width={48} />
    } else if(flowTypeId === 3) {
        return <UtilityIcon width={48} />
    } else if(flowTypeId === 4) {
        return <ChatIcon width={48} />
    }

    return null;
}